import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/static-property-placement */

/* eslint-disable react/sort-comp */
import React from 'react';
import { Provider, connect } from 'react-redux';
import configureStore from '../../store/configureStore';
import rootSaga from '../../sagas';
import { getUserDetails } from '../../redux/userDetails/getDetails';
import { mergeState } from '../../redux/mergeState';

var Context = /*#__PURE__*/function (_React$Component) {
  _inherits(Context, _React$Component);

  var _super = _createSuper(Context);

  function Context(props) {
    var _this;

    _classCallCheck(this, Context);

    _this = _super.call(this, props);
    _this.store = configureStore(props.dispatch);
    return _this;
  }

  _createClass(Context, [{
    key: "UNSAFE_componentWillMount",
    value: // eslint-disable-next-line camelcase
    function UNSAFE_componentWillMount() {
      this.store.runSaga(rootSaga);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.store.dispatch(getUserDetails());
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.state !== this.props.state) {
        this.store.dispatch(mergeState(nextProps.state));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        store: this.store
      }, this.props.children);
    }
  }]);

  return Context;
}(React.Component);

_defineProperty(Context, "defaultProps", {
  dispatch: function dispatch() {}
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    state: state
  };
};

export default Context;
export var ConnectedContext = connect(mapStateToProps)(Context);